import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-consent-popup',
  templateUrl: './consent-popup.component.html',
  styleUrls: ['./consent-popup.component.scss'],
})
export class ConsentPopupComponent {
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  constructor(public activeModal: NgbActiveModal, private router: Router) {}

  action(status: boolean) {
    this.passEntry.emit(status);
    this.activeModal.close();
  }

  openPolicy() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/privacy-policy`])
    );
    window.open(url, '_blank');
  }
}
